import CreditCardExpirationTrigger from './creditCardExpirationTrigger/CreditCardExpirationTrigger.vue';
import FailedAutoChargeTrigger from './failedAutoChargeTrigger/FailedAutoChargeTrigger.vue';
import UnpaidInvoiceTrigger from './unpaidInvoiceTrigger/UnpaidInvoiceTrigger.vue';

const IntegrationModals = {
    CreditCardExpiration: CreditCardExpirationTrigger,
    FailedAutoCharge: FailedAutoChargeTrigger,
    UnpaidInvoice: UnpaidInvoiceTrigger,
};

export default {
    IntegrationModals,
    ...IntegrationModals,
};
